import { Component, OnInit } from '@angular/core'
import { AtomModule } from '../../atom/atom.module'
import { CommonModule } from '@angular/common'
import { SearchResult } from '../../gql/generated'
import { GameCardGammaComponent } from '../game-card-gamma/game-card-gamma.component'
import { SearchService } from '../../service/search.service'
import { NzGridModule } from 'ng-zorro-antd/grid'
import { NzSpaceModule } from 'ng-zorro-antd/space'

@Component({
  selector: 'app-game-ad-beta',
  templateUrl: './game-ad-beta.component.html',
  styleUrls: ['./game-ad-beta.component.less'],
  standalone: true,
  imports: [AtomModule, CommonModule, GameCardGammaComponent, NzGridModule, NzSpaceModule],
})
export class GameAdBetaComponent implements OnInit {
  data: SearchResult[] = []

  constructor(private searchService: SearchService) {}

  ngOnInit(): void {
    this.searchService.search('astro').subscribe({
      next: (result) => {
        this.data.push(result.data.search.items[0] as SearchResult)
        this.data.push(result.data.search.items[0] as SearchResult)
        this.data.push(result.data.search.items[0] as SearchResult)
      }
    });
  }
}
